import { getPipBySymbol, getTypeBySymbol } from "../interfaces/quote.data";
import { DataService } from "../services/data/data.service";
import { Observable, Observer, Subject } from "rxjs";
import { SymbolTypeEnum } from "../enums/SymbolType.enum";
import { Workspace } from "./workspace.data";
import { Utils } from "../utils";
import { Assets } from '../api/DixApiClient';
import {Providers} from "../enums/providers";
export class BoxQuotaData {
    low: number = -1;
    high: number = -1;

    buyUp: boolean = true;
    sellUp: boolean = true;
    isFav: boolean = false;
    

    private _searchVisible: boolean = true;
    public get searchVisible (): boolean {
        return this._searchVisible;
    }
    public set searchVisible ( value: boolean ) {
        this._searchVisible = value;
    }

    askUp: boolean = true;
    askSubject: Subject<number> = new Subject<number>();
    sortOrder: number = 1000000;
    initialSortOrder: number = -1;
    MarginPerc:number = 3.33;

    private _oneClickTrade: boolean = false;
    public get oneClickTrade(): boolean {
        return this._oneClickTrade;
    }
    public set oneClickTrade(v: boolean) {
        if (this._oneClickTrade != v) {
            this._oneClickTrade = v;
            this.save1Click();
        }
    }

    private _selectedVolume: number = 100000;
    public get selectedVolume(): number {
        return this._selectedVolume;
    }

    public set selectedVolume(v: number) {
        if (this._selectedVolume != v) {
            this._selectedVolume = v;
            this.save1Click();
        }
    }

    private _tradeSizeLabel: string = "Trade size: 100k";
    public get tradeSizeLabel(): string {
        return this._tradeSizeLabel;
    }

    public set tradeSizeLabel(v: string) {
        if (this._tradeSizeLabel != v) {
            this._tradeSizeLabel = v;
            this.save1Click();
        }
    }

    constructor(protected workspace: Workspace) {}

    private _symbol: string = "";
    public get Symbol(): string {
        return this._symbol;
    }
    public set Symbol(v: string) {
        if (this._symbol != v) {
            this._symbol = v;
            this._pip = getPipBySymbol(v);
            this.Type = getTypeBySymbol(v);
            this.init1Click();
        }
    }

    private _Bid: number = -1;
    get Bid(): number {
        return this._Bid;
    }

    private _pip: number = 0;
    get Pip(): number {
        return Math.pow(10, -(this.Decimal - 1));
        return this._pip;
    }

    set Pip(v: number) {
        this._pip = v;
    }

    private _type: SymbolTypeEnum = SymbolTypeEnum.Unknown;
    get Type(): SymbolTypeEnum {
        return this._type;
    }

    set Type(v: SymbolTypeEnum) {
        this._type = v;
    }

    private _decimal: number = 5;
    get Decimal(): number {
        return this._decimal;
    }

    set Decimal(v: number) {
        this._decimal = v;
    }

    set Bid(v: number) {
        if (v !== this._Bid) {
            this.buyUp = v !== -1 && v >= this._Bid;
            this.low = this.low < v || this.low === -1 ? v : this.low;
            this.high = this.high > v || this.high === -1 ? v : this.high;
            this._Bid = v;

            if(!this.customVisibility)
            {
               this.visible = this._Ask > 0 && this._Bid > 0;
            }

            
           
        }
        this.Spread = (this.Ask - this.Bid) / this.Pip;
    }

    private _Ask: number = -1;
    get Ask(): number {
        return this._Ask;
    }

    set Ask(v: number) {
        if (v !== this._Ask) {
            this.sellUp = v !== -1 && v >= this._Ask;
            this._Ask = v;
            this.askUp = this.sellUp;

            if(!this.customVisibility)
            {
                 this.visible = this._Ask > 0 && this._Bid > 0;
            }
           
            this.sendAsk();
            
           
        }
        this.Spread = (this.Ask - this.Bid) / this.Pip;
    }

    sendAsk() {
        this.askSubject.next(this._Ask);
    }

    private _Spread: number = -1;
    public get Spread(): number {
        return this._Spread;
    }
    public set Spread(value: number) {
        
        this._Spread = value;
    }

    init1Click() {
        Utils.waitFor(
            () => this.workspace.IsLoged(),
            () => {
                if (this.workspace.SymbolOneClicks[this.Symbol]) {
                    this._oneClickTrade = this.workspace.SymbolOneClicks[this.Symbol].enabled;
                    this._selectedVolume = this.workspace.SymbolOneClicks[this.Symbol].volume;
                    this._tradeSizeLabel = this.workspace.SymbolOneClicks[this.Symbol].label;
                } else {
                    this._oneClickTrade = false;
                    this._selectedVolume = 100000;
                    this._tradeSizeLabel = "Trade size: 100k";
                }

                // let v1 = Number(this.workspace.getFromUserStore(`${this.Symbol}-1c`) || "");
                // v1 = isNaN(v1) ? 0 : v1;
                // this._oneClickTrade = v1 != 0;

                // var vs = this.workspace.getFromUserStore(`${this.Symbol}-1cv`);
                // v1 = Number(vs);
                // v1 = isNaN(v1) || v1 <= 0 ? 100000 : v1;
                // this._selectedVolume = v1;

                // this._tradeSizeLabel=this.workspace.getFromUserStore(`${this.Symbol}-trl`) || "Trade size: 100k";
                // this._tradeSizeLabel=this._tradeSizeLabel==''?"Trade size: 100k":this._tradeSizeLabel;
            }
        );
    }

    private _customVisibility = false;
    public get customVisibility () {
        return this._customVisibility;
    }
    public set customVisibility ( value ) {
        this._customVisibility = value;
    }


    save1Click() {
        Utils.waitFor(
            () => this.workspace.IsLoged(),
            () => {
                this.workspace.setSymbolOneClick(
                    this.Symbol,
                    this._oneClickTrade,
                    this._selectedVolume,
                    this._tradeSizeLabel
                );
                // this.workspace.setToUserStore(`${this.Symbol}-1c`, this._oneClickTrade?'1':'0');
                // this.workspace.setToUserStore(`${this.Symbol}-1cv`, this._selectedVolume.toString());
                // this.workspace.setToUserStore(`${this.Symbol}-trl`, this._tradeSizeLabel);
            }
        );
    }

    private _visible: boolean = false;
    public get visible (): boolean {


        if(this.workspace.competitionAccountList.indexOf(this.workspace.activeAccountIdBySet)>-1 || this.workspace.currentProvider!=Providers.DEMO)
        {
           // console.log(this.workspace.currentTournaments[0].tournamentAssets);
            if(this.Type=='forex' && this.workspace.allowedForexSymbols.indexOf(this.Symbol)<0)//&& this.workspace.currentTournaments[0].tournamentAssets.Assets.indexOf(0))
            {
                return false;
            }
        }
      
        return this._visible;
    }
    public set visible ( value: boolean ) {
        this._visible = value;
    }

 

}

export const allowedForexSymbols = [
   "AUD/CAD",
   "AUD/JPY",
   "AUD/NZD",
   "AUD/USD",
   "AUD/CHF",
   "CAD/JPY",
   "CAD/CHF",
   "CHF/JPY",
    "EUR/AUD",
    "EUR/CAD",
    "EUR/CHF",
    "EUR/GBP",
    "EUR/JPY",
    "EUR/NZD",
    "EUR/USD",
   "GBP/CHF",
   "GBP/JPY",
   "GBP/USD",
    "GBP/AUD",
    "GBP/CAD",
    "GBP/NZD",
    "NZD/JPY",
    "NZD/USD",
    "NZD/CAD",
    "NZD/CHF",
    "USD/CAD",
    "USD/CHF",
    "USD/JPY",
    "TRY/JPY",
  ];